module.exports = __webpack_public_path__ + "static/media/ButtonPlus.668aba45.png";